"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentDateTime = getCurrentDateTime;
exports.getDateInfo = getDateInfo;
exports.getDateRange = getDateRange;
exports.createLuxonDay = createLuxonDay;
exports.oneOfWeekdays = exports.MONTHS = exports.WeekDays = exports.getDisabledIntervals = void 0;

var _luxon = require("luxon");

var _propTypes = require("prop-types");

var getDisabledIntervals = function getDisabledIntervals(disabledDates) {
  if (!disabledDates || !disabledDates.length) return [];
  return disabledDates.map(function (group) {
    var start = group.start,
        end = group.end;
    var luxonStartDate = getDateInfo(start).date;
    var luxonEndDate = getDateInfo(end).date;
    return getDateRange(luxonStartDate, luxonEndDate);
  });
};

exports.getDisabledIntervals = getDisabledIntervals;

function getCurrentDateTime() {
  return _luxon.DateTime.local();
}

function getDateInfo(isoDate) {
  var date = _luxon.DateTime.fromISO(isoDate);

  return {
    date: date,
    year: date.year,
    month: date.month,
    day: date.day
  };
}

function getDateRange(start, end) {
  var interval = _luxon.Interval.fromDateTimes(start, end);

  return interval.isValid ? interval : undefined;
}

function createLuxonDay(_ref) {
  var year = _ref.year,
      month = _ref.month,
      day = _ref.day;
  return day && month && year ? _luxon.DateTime.local(year, month, day) : undefined;
}

var WeekDays = {
  MON: 'Mon',
  TUE: 'Tue',
  WED: 'Wed',
  THU: 'Thu',
  FRI: 'Fri',
  SAT: 'Sat',
  SUN: 'Sun'
};
exports.WeekDays = WeekDays;
var MONTHS = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December'
};
exports.MONTHS = MONTHS;
var oneOfWeekdays = (0, _propTypes.oneOf)([WeekDays.MON, WeekDays.TUE, WeekDays.WED, WeekDays.THU, WeekDays.FRI, WeekDays.SAT, WeekDays.SUN]);
exports.oneOfWeekdays = oneOfWeekdays;